const defaultTheme = {
  colors: {
    primaryWhite: '#FFFFFF',
    primaryBlack: '#333',
    primaryRed: '#ff0000',
    PrimaryBlue: '#0078ff',
    unSelectedText: '#666',
    secondaryTextColor: '#777777',
    backgroundColor: '#F1F6F9',
    dividerColor: '#e7e9ec',
    lineColor: '#f3f3f3',
    borderColor: '#C2C4C8',
    buttonBorderColor: '#e5e5e5',
  },

  sizes: {
    layoutWidth: '1080px',
    contentPadding: '1.6rem',
    contentBorderRadius: '0.1rem',
    sectionTopMargin: '2.4rem',
    labelWidth: '10rem',
    borderRadius: '6px',
    lineHeight: '1.67',
  },
};

export default defaultTheme;
